import React from "react";

import PropTypes from "prop-types";
import TicketItem from "../TicketItem";
import SkeletonWrapper from "../../../UI/skeletonWrapper";
import { Spinner } from "reactstrap";
import PaginationComponent from "../../../UI/pagnationComponent";

const TicketList = ({
  tickets,
  onSelectTicket,
  searchTerm,
  onSearchChange,
  selectedTicket,
  statusOptions,
  isLoading,
  onFilterChange,
  currentPage,
  totalPages,
  onPageChange,
  total,
  perPage,
}) => {

  return (
    <div className="card add rounded-4">
      <div className="card-body">
        {/* <div className="col-12 mb-2">
          <input
            type="search"
            className="form-control"
            placeholder="Search by Order ID, Name, Phone"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div> */}

        <div className="row mb-2">
          <div className="col-12 col-md-6">
            <label htmlFor="typeSelect">النوع</label>
            <select
              id="typeSelect"
              className="form-select"
              onChange={(e) => onFilterChange("type", e.target.value)}
            >
              <option value="user">دعم العملاء</option>
              <option value="courier">دعم السائقين</option>
              <option value="vendor">دعم المتاجر</option>
            </select>
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="statusSelect">الحالة</label>
            <select
              id="statusSelect"
              className="form-select"
              onChange={(e) => onFilterChange("status", e.target.value)}
            >
              <option value="">All</option>
              {statusOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div> */}
        </div>

        <div className="list-group mt-2"  style={{ maxHeight: "70vh" ,overflowY: "auto"}}>
          {isLoading ? (  
            <div className="text-muted">
              جاري التحميل... <Spinner />
            </div>
          ) : tickets.length === 0 ? (
            <div className="text-center text-muted">No tickets found</div>
          ) : (
            tickets.map((t) => (
              <TicketItem
                key={t.ticketID}
               
                selectedTicket={selectedTicket}
                ticketID={t.ticketID}
                customer={t.customer_name}
                issue={t.issue_type}
                status={t.status_badge}
                priority={t.Priority}
                time={t.time}
                onClick={() => onSelectTicket(t)}
              />
            ))
          )}
        </div>
        {totalPages > 1 && (
          <PaginationComponent
            setCurrentPage={onPageChange}
            currentPage={currentPage}
            totalItems={total}
            itemsPerPage={perPage}
          />
        )}
      </div>
    </div>
  );
};

export default TicketList;
